import React from "react";
import { Link } from "react-router-dom";
import { TRENDING_WEAR_CATS } from "@/lib/constants";
export default function TrendingWear() {
  return (
    <main className="sq-container py-12" data-testid="trending-wear-page">
      <div className="sq-eyebrow">In Vogue</div>
      <h1 className="font-display text-5xl md:text-6xl mt-2">Trending Wear</h1>
      <div className="space-y-12 mt-10">
        {TRENDING_WEAR_CATS.map((c, i) => (
          <div key={c.key} className={`grid grid-cols-1 md:grid-cols-2 gap-10 items-center ${i % 2 === 1 ? "md:[&>*:first-child]:order-2" : ""}`} data-testid={`tw-cat-${c.key}`}>
            <img src={c.image} alt={c.label} className="aspect-[4/5] w-full object-cover" />
            <div>
              <div className="sq-eyebrow text-squire-jeans">Category</div>
              <h2 className="font-display text-5xl mt-2">{c.label}</h2>
              <p className="text-[#4B5563] mt-4 max-w-md">{c.why}</p>
              <Link to={`/category/${c.key}`} className="sq-btn-primary mt-6">Shop {c.label}</Link>
            </div>
          </div>
        ))}
      </div>
    </main>
  );
}
